import { SynchronousStorageService } from '../SynchronousStorageService';

export class SessionStorageService extends SynchronousStorageService {
  protected storage: Storage = sessionStorage;

  constructor() {
    super()
  }
}
